// DataTransfer type of a logic palette entry dragged onto the canvas.
export const LOGIC_PALETTE_MIME = 'application/x-openhasp-logic-node';

export function findPaletteEntry(palette, id) {
    return palette.flatMap(group => group.entries).find(entry => entry.id === id) ?? null;
}
